import styled from "@emotion/styled";
import { Box } from "@mui/material";
import React from "react";
import TextContainer from "../Texts/TextContainer";
import { AppbarTopic } from "../Texts/styles";

type props = {
    title?: string,
    coloredTitle?: string,
    children?: React.ReactNode
}
const Nav = styled(Box)({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    marginBottom: "1rem",
    alignItems: "center",
    justifyContent: "space-between"
})
export default function Navbar({ children, title, coloredTitle = "" }: props) {

    return (
        <Nav>
            <TextContainer width="fit-content" textWrap="nowrap" {...AppbarTopic} zIndex={10} position="relative">
                {title}  {coloredTitle}
            </TextContainer>&nbsp;
            {children}
        </Nav>
    )
}

